module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_5.4f33058e.png";